import { render } from "./deposit-list.vue?vue&type=template&id=18f078e8"
import script from "./deposit-list.vue?vue&type=script&lang=js"
export * from "./deposit-list.vue?vue&type=script&lang=js"

import exportComponent from "/home/copycrack-client-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__